module.exports = __webpack_public_path__ + "static/package-3ddeaabf37af6174e105ca9ae6d48ac6.png";